import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import {
  addSupplierPrivateInquiryAction,
  editSupplierPrivateInquiryAction,
  getSupplierPrivateInquiryAction
} from '../../../../modules/inquiries/suppliers/private/Actions';
import {
  inquiryByIdSelector,
  supplierPrivateInquiriesIsLoadingSelector,
  PrivateSupplierListSelector,
  inquiryStagingByIdSelector
} from '../../../../modules/inquiries/suppliers/private/Selectors';
import { customerDataSelector } from '../../../../modules/auth/Selectors';

import { getSuppliersAction } from '../../../../modules/suppliers/Actions';
import {
  suppliersAsLabelAndValueSelector,
  suppliersSelector
} from '../../../../modules/suppliers/Selectors';

import { getSupplierProductsAction } from '../../../../modules/supplierProducts/Actions';
import { suppliersProductsAsLabelAndValueSelector } from '../../../../modules/supplierProducts/Selectors';
import Card from '../../../../components/UI/Card/Card';

import {
  InputField,
  TextArea,
  Select,
  SearchableSelect,
  Upload
} from '../../../../components/form/';
import * as Yup from 'yup';
import ModerationForm from '../../../../components/form/FormGroup';
import { values } from 'lodash';
import { checkCustomerLimitsAction } from '../../../../modules/customerLimits/Actions';
import getLangData from '../../../../utils/getLangData';

const schema = () =>
  Yup.object().shape({
    cfirstName: Yup.string().default(''),
    clastName: Yup.string().default(''),
    supplierId: Yup.string()
      .default('')
      .required(getLangData().fields.required),

    aproductId: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    aproductName: Yup.string().default(''),
    qtyRequired: Yup.string().default(0),
    message: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    attachment: Yup.string().default('')
  });

const ViewPrivateInquiry = props => {
  const {
    isLoading,
    pendingIsLoading,

    inquiryID,

    inquiry,
    getPrivateInquiry,
    moderateCreateSupplierPrivateInquiry,
    getArtisans,
    getSupplierProducts,
    supplierProducts,
    supplier,
    addPrivateIquiry,
    editPrivateInquiry,
    customerData,
    suppliers,
    checkCustomerLimit
  } = props;

  // for testing only
  const customerId = customerData._id;
  const mappedSuppliers = supplier.map(el => {
    return {
      _id: el._id,
      name: el.businessName
    };
  });
  const mappedProducts = suppliers
    ?.find(el => el._id === inquiry?.supplierId)
    ?.products.map(el => {
      return { value: el._id, label: el.name };
    });
  // const mappedInquiry = inquiry.map()

  useEffect(() => {
    getArtisans();
    getSupplierProducts();
    console.log(inquiryID);
    if (inquiryID !== 'create') {
      getPrivateInquiry(inquiryID);
    }
    checkCustomerLimit({ id: customerId, limitType: 0 });
    console.log(inquiryID);
  }, [inquiryID, getPrivateInquiry]);

  return (
    <Formik
      validationSchema={schema()}
      enableReinitialize
      initialValues={inquiry ? { ...inquiry } : schema().cast()}
      onSubmit={values => {
        const productName = suppliers
          .find(el => el._id === values.supplierId?._id)
          ?.products.map(el => {
            return el.name;
          });
        // values.aproductName = productName[0];
        // values.cfirstName = customerData.businessName;
        // values.supplierId = values.supplierId._id;
        // values.clastName = customerData.lastName;
        const data = {
          ...values,
          aproductName: inquiry
            ? values?.supplierProduct?.name
            : productName[0],
          cfirstName: customerData.businessName,
          clastName: customerData.businessName,
          supplierId: inquiry ? values.supplierId : values.supplierId._id,
          customerId,
          attachment: values.attachment
        };
        if (inquiryID === 'create') {
          addPrivateIquiry(data);
          console.log(data);
        } else {
          editPrivateInquiry('', {
            privateSupplierInquiryID: values._id,
            ...data
          });
        }
      }}
    >
      {({ values, handleSubmit, setFieldValue, errors }) => {
        return (
          <ModerationForm
            handleSubmit={handleSubmit}
            heading={getLangData().buttons.private_inquiry}
            isLoading={isLoading || pendingIsLoading}
            errors={errors}
            noSubmit={inquiry ? !inquiry.active : false}
          >
            {inquiry ? (
              <InputField
                disabled
                name='supplierProfileDetail.businessName'
                label={getLangData().profile_types.supplier}
              />
            ) : (
              <SearchableSelect
                label={getLangData().profile_types.supplier}
                name={'supplierId'}
                getItems={getArtisans}
                options={mappedSuppliers}
              />
            )}

            {/* {console.log(values)} */}
            {/* {console.log(errors)} */}
            {values.supplierId?._id && (
              <Select
                label={getLangData().fields.product_name}
                name='aproductId'
                options={suppliers
                  ?.find(el => el._id === values.supplierId?._id)
                  ?.products.map(el => {
                    return { value: el._id, label: el.name };
                  })}
              />
            )}
            {/* {console.log(
              suppliers
                ?.find((el) => el._id === values?.supplierId)
                ?.products.map((el) => {
                  return { value: el._id, label: el.name };
                })
            )} */}
            {inquiry && (
              <InputField
                name='supplierProduct.name'
                disabled
                label={getLangData().fields.product_name}
              />
            )}
            <TextArea
              name='message'
              label={getLangData().fields.message}
              disabled={inquiry ? !inquiry.active : false}
            />
            <InputField
              name='qtyRequired'
              label={getLangData().components.private_inquiry.quantity}
              type='number'
              disabled={inquiry ? !inquiry.active : false}
            />
            {/* <Upload
              data={{ userID: customerId }}
              name='attachment'
              label='Inquiry Image :'
              S3Bucket='warshatna-users'
              // API="customer/customer-category-image-signedurl/"
              API='users/user-profile-image-signedurl'
              disabled={inquiry ? !inquiry.active : false}
            /> */}
            {inquiry?.proposal ? (
              <>
                {/* <p>{el.message}</p>
								<p>{el.price}</p> */}
                <Card
                  logo={inquiry?.supplierProfileDetail?.logo}
                  attach={inquiry?.proposal.attachment}
                  message={inquiry?.proposal?.message}
                  price={inquiry?.proposal?.price}
                  name={inquiry?.supplierProfileDetail?.businessName}
                  phone={inquiry?.supplierProfileDetail?.contactPersonPhone}
                  address={inquiry?.supplierProfileDetail?.contactPersonEmail}
                />
                {/* <Card message={el.message} price={el.price} name={el.supplierData.businessName} /> */}
              </>
            ) : (
              <p>No Proposals Yet</p>
            )}
          </ModerationForm>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const inquiryID = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    inquiryID,
    moderationId,
    inquiry: inquiryByIdSelector(state, inquiryID),
    isLoading: supplierPrivateInquiriesIsLoadingSelector(state),
    supplier: suppliersAsLabelAndValueSelector(state),
    supplierProducts: suppliersProductsAsLabelAndValueSelector(state),
    customerData: customerDataSelector(state),
    suppliers: suppliersSelector(state),
    staging: inquiryStagingByIdSelector(state, inquiryID)
  };
};

const mapDispatchToProps = {
  getPrivateInquiry: getSupplierPrivateInquiryAction,
  getArtisans: getSuppliersAction,
  getSupplierProducts: getSupplierProductsAction,
  editPrivateInquiry: editSupplierPrivateInquiryAction,
  addPrivateIquiry: addSupplierPrivateInquiryAction,
  checkCustomerLimit: checkCustomerLimitsAction
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPrivateInquiry);
